// Lifedocs's public GCS bucket. Branded org logos, email-template assets,
// and other resources that must be fetchable by unauthenticated clients
// (pre-auth browser, email renderer) live here.
//
// Duplicated constants and URL builders MUST mirror this file. Specifically:
// - apps/functions/src/organisations/utils/migrate-logo-to-gcs.ts
// - apps/butler/src/scripts/backfill-org-slugs.ts
// Those files can't import from @ld/utils (no workspace dep on functions/
// butler side), so they keep their own copies. Keep them aligned by hand
// when the bucket moves.

export const LIFEDOCS_PUBLIC_BUCKET = 'lifedocs-public';
export const LIFEDOCS_PUBLIC_URL_PREFIX = `https://storage.googleapis.com/${LIFEDOCS_PUBLIC_BUCKET}/`;

export const publicOrgLogoUrl = (slug: string): string =>
  `${LIFEDOCS_PUBLIC_URL_PREFIX}organisations/${slug}-logo.png`;

export const isInPublicBucket = (url: string): boolean =>
  url.startsWith(LIFEDOCS_PUBLIC_URL_PREFIX);
